export const studentData = {
  // Main title/description of the student report
  message: "Enhanced and Very Useful Student Report",
  data: {
    examOverview: {
      // Array containing detailed analysis of each answered question
      checked_answers: [
        {
          question_number: "Q.1 (A)",
          sub_questions: [
            {
              sub_question_number: "Q.1 (A)(1)",
              student_answer: "(c)",
              marks_awarded: 1,
              deducted_marks: 0,
              reason: "Correct identification of anaphase.",
            },
            {
              sub_question_number: "Q.1 (A)(2)",
              student_answer: "(a)",
              marks_awarded: 0,
              deducted_marks: 1,
              reason:
                "Student chose (a), but unisexual flowers have either androecium or gynoecium, not both.",
            },
            {
              sub_question_number: "Q.1 (A)(3)",
              student_answer: "(d)",
              marks_awarded: 1,
              deducted_marks: 0,
              reason: "Correctly identified humans as omnivorous.",
            },
            {
              sub_question_number: "Q.1 (A)(4)",
              student_answer: "(d)",
              marks_awarded: 1,
              deducted_marks: 0,
              reason:
                "Correctly stated that pigeon's heart has four compartments.",
            },
            {
              sub_question_number: "Q.1 (A)(5)",
              student_answer: "d",
              marks_awarded: 0,
              deducted_marks: 1,
              reason:
                "Wrote 'All of the above' instead of the specific bacterium (Nostoc).",
            },
          ],
          total_marks_awarded: 3,
          total_marks_possible: 5,
        },
        {
          question_number: "Q.1 (B)",
          parts: [
            {
              question_number: "Q.1 (B)(1)",
              student_answer: "Penis",
              marks_awarded: 0.5,
              deducted_marks: 0.5,
              reason:
                "Mentioned only 'penis'; did not list other unpaired organs (e.g., prostate gland).",
            },
            {
              question_number: "Q.1 (B)(2)",
              student_answer: "Scatter curved grooves",
              marks_awarded: 0,
              deducted_marks: 1,
              reason:
                "The name given does not match the expected conserved forest name.",
            },
            {
              question_number: "Q.1 (B)(3)",
              student_answer: "inverter",
              marks_awarded: 1,
              deducted_marks: 0,
              reason:
                "Correctly identified the device that converts DC solar power to AC.",
            },
            {
              question_number: "Q.1 (B)(4)",
              student_answer: "",
              marks_awarded: 0,
              deducted_marks: 1,
              reason: "No answer was provided.",
            },
            {
              question_number: "Q.1 (B)(5)",
              student_answer: "Mental stress",
              marks_awarded: 1,
              deducted_marks: 0,
              reason:
                "Correctly noted that laughter clubs drive away mental stress.",
            },
          ],
          total_marks_awarded: 2.5,
          total_marks_possible: 5,
        },
        {
          question_number: "Q.2 (A)",
          sub_questions: [
            {
              sub_question_number: "Q.2 (A)(1)",
              student_answer: "(i) Embryological evidences ...",
              marks_awarded: 1.5,
              deducted_marks: 0.5,
              reason:
                "Discussed similarities in early stages but did not clarify that these similarities gradually decrease.",
            },
            {
              sub_question_number: "Q.2 (A)(2)",
              student_answer: "(ii) Disaster management ...",
              marks_awarded: 0,
              deducted_marks: 2,
              reason:
                "The response focuses on disaster management rather than saving energy.",
            },
          ],
          total_marks_awarded: 1.5,
          total_marks_possible: 4,
        },
        {
          question_number: "Q.2 (B)",
          parts: [
            {
              question_number: "Q.2 (B)(1)",
              student_answer: "(i) Regeneration means ...",
              marks_awarded: 1,
              deducted_marks: 1,
              reason:
                "Recognized tail regrowth but incorrectly labeled it unisexual and gave human skin as a confusing example.",
            },
            {
              question_number: "Q.2 (B)(2)",
              student_answer: "(iii) 1) Methanol 2) Ethanol 3) Natural gas",
              marks_awarded: 0.5,
              deducted_marks: 1.5,
              reason:
                "Mentioned ethanol, but methanol and natural gas are not typical biomass fuels.",
            },
            {
              question_number: "Q.2 (B)(3)",
              student_answer: "(v) Having a good personality ...",
              marks_awarded: 1.5,
              deducted_marks: 0.5,
              reason:
                "Explained social connectivity and some factors for good social health; omitted certain aspects like acceptance and respect.",
            },
          ],
          total_marks_awarded: 3,
          total_marks_possible: 6,
        },
        {
          question_number: "Q.3",
          parts: [
            {
              question_number: "Q.3(1)",
              student_answer: {
                "3.1 (i)": "Seven crore years ago",
                "3.1 (ii)": "Lemurs",
                "3.1 (iii)": "Two",
                "3.1 (iv)": "Ramapithecus",
                "3.1 (v)": "Neanderthal man",
                "3.1 (vi)": "Agriculture",
              },
              marks_awarded: 3,
              deducted_marks: 0,
              reason:
                "All fill-in-the-blanks correctly matched the required words.",
            },
            {
              question_number: "Q.3(2)",
              student_answer: {
                diagram: "Punnett square ...",
                written_explanation: [
                  "Male gametes = (22+X) or (22+Y)",
                  "Female gametes = (22+X)",
                  "Male chromosome decides child's gender",
                  "Hence statement is true",
                ],
              },
              marks_awarded: 3,
              deducted_marks: 0,
              reason:
                "Clear depiction of sex determination with both diagram and explanation.",
            },
            {
              question_number: "Q.3(6)",
              student_answer: {
                written_explanation: [
                  "1. Biotechnology is used ...",
                  "2. Crops grow faster ...",
                  "3. BT cotton and BT brinjal ...",
                  "4. Genes of crops modified ...",
                ],
              },
              marks_awarded: 3,
              deducted_marks: 0,
              reason:
                "Mentioned biofertilizers, GM crops, and how biotechnology benefits agriculture.",
            },
          ],
          total_marks_awarded: 9,
          total_marks_possible: 15,
          note: "Student attempted only three out of the required five sub-questions.",
        },
        {
          question_number: "Q.4",
          choice_attempted: "Q.4 (2)",
          parts: [
            {
              question_number: "4.2",
              student_answer: {
                diagram_description: "Accurately labeled ecosystem chart ...",
                answers: {
                  Abiotic_components: [
                    "Physical factors: Air, water vapor, minerals, soil, sunlight",
                    "Inorganic substances: Hydrogen, Oxygen, Nitrogen, Calcium, Iron, Sodium, Potassium",
                  ],
                  Biotic_components: [
                    "Autotrophic: Producers (Plants)",
                    "Heterotrophic: Consumers (Animals), Decomposers (Fungi)",
                    "Consumers: Primary consumers, Secondary consumers, Tertiary consumers",
                  ],
                },
              },
              marks_awarded: 5,
              deducted_marks: 0,
              reason:
                "Completely and accurately filled the ecosystem classification boxes.",
            },
          ],
          total_marks_awarded: 5,
          total_marks_possible: 5,
        },
      ],

      // Overall exam statistics and performance summary
      examOverview: {
        totalMarksScored: 24, // Total marks obtained by student
        maximumMarks: 40, // Maximum possible marks in exam
        totalQuestions: 25, // Total number of questions in exam
        questionsAttempted: 23, // Number of questions student attempted
        exam_summary:
          "Great effort! You did really well in Heredity & Evolution (Ch.1) and Cell Biology & Biotechnology (Ch.8). Some answers in Microbiology (Ch.7) and Energy Conservation (Ch.5) were either incomplete or incorrect (like missing 'Nostoc' or mixing up biomass fuels). With careful reading and more practice, you can do even better!",
      },
      questions_compulsory: 25, // Total number of mandatory questions
      questions_attempted: 23, // Total questions answered by student
    },

    // Topic-wise performance analysis with correct chapters as per Maharashtra Board
    topicPerformance: [
      {
        topicName: "Heredity and Evolution",
        marksScored: 7.5,
        totalMarksAvailable: 8,
        performanceTag: "STRENGTH",
        questionsAttemptedPercentage: 100,
      },
      {
        topicName: "Life Processes in Living Organisms Part - 1",
        marksScored: 1,
        totalMarksAvailable: 2,
        performanceTag: "OPPORTUNITY",
        questionsAttemptedPercentage: 50,
      },
      {
        topicName: "Life Processes in Living Organisms Part - 2",
        marksScored: 1.5,
        totalMarksAvailable: 3,
        performanceTag: "OPPORTUNITY",
        questionsAttemptedPercentage: 50,
      },
      {
        topicName: "Environmental Management",
        marksScored: 5,
        totalMarksAvailable: 6,
        performanceTag: "STRENGTH",
        questionsAttemptedPercentage: 100,
      },
      {
        topicName: "Towards Green Energy",
        marksScored: 4.5,
        totalMarksAvailable: 8,
        performanceTag: "WEAKNESS",
        questionsAttemptedPercentage: 75,
      },
      {
        topicName: "Animal Classification",
        marksScored: 1,
        totalMarksAvailable: 1,
        performanceTag: "STRENGTH",
        questionsAttemptedPercentage: 100,
      },
      {
        topicName: "Introduction to Microbiology",
        marksScored: 0,
        totalMarksAvailable: 2,
        performanceTag: "WEAKNESS",
        questionsAttemptedPercentage: 50,
      },
      {
        topicName: "Cell Biology and Biotechnology",
        marksScored: 4,
        totalMarksAvailable: 4,
        performanceTag: "STRENGTH",
        questionsAttemptedPercentage: 100,
      },
      {
        topicName: "Social Health",
        marksScored: 2.5,
        totalMarksAvailable: 3,
        performanceTag: "STRENGTH",
        questionsAttemptedPercentage: 100,
      },
      {
        topicName: "Disaster Management",
        marksScored: 0,
        totalMarksAvailable: 0,
        performanceTag: "NA",
        questionsAttemptedPercentage: 0,
      },
    ],

    // Detailed question-by-question analysis per chapter
    detailedPerformance: [
      {
        topicName: "Heredity and Evolution",
        questions: [
          {
            questionNumber: "Q.2(A)(1)",
            questionDescription: "Embryological evidences for evolution",
            marksScored: 1.5,
            maximumMarks: 2,
          },
          {
            questionNumber: "Q.3(1)",
            questionDescription: "Evolution timeline fill-in-the-blanks",
            marksScored: 3,
            maximumMarks: 3,
          },
          {
            questionNumber: "Q.3(2)",
            questionDescription: "Sex determination in humans",
            marksScored: 3,
            maximumMarks: 3,
          },
        ],
        chapterFeedback:
          "Excellent clarity on evolutionary concepts, embryological evidence, and sex determination.",
      },
      {
        topicName: "Life Processes in Living Organisms Part - 1",
        questions: [
          {
            questionNumber: "Q.1(A)(2)",
            questionDescription: "Unisexual flower presence",
            marksScored: 0,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.1(A)(3)",
            questionDescription: "Humans as omnivorous animals",
            marksScored: 1,
            maximumMarks: 1,
          },
        ],
        chapterFeedback:
          "Moderate knowledge of fundamental life processes; revise flower types to improve accuracy.",
      },
      {
        topicName: "Life Processes in Living Organisms Part - 2",
        questions: [
          {
            questionNumber: "Q.1(B)(1)",
            questionDescription: "Unpaired male reproductive organs",
            marksScored: 0.5,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.2(B)(1)",
            questionDescription: "Regeneration in organisms",
            marksScored: 1,
            maximumMarks: 2,
          },
        ],
        chapterFeedback:
          "Fair understanding of regeneration and human reproductive systems. Ensure completeness of examples.",
      },
      {
        topicName: "Environmental Management",
        questions: [
          {
            questionNumber: "Q.1(B)(2)",
            questionDescription:
              "Forest conserved in the name of god (Sacred groves)",
            marksScored: 0,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.4(2)",
            questionDescription: "Ecosystem classification diagram",
            marksScored: 5,
            maximumMarks: 5,
          },
        ],
        chapterFeedback:
          "Excellent ecosystem diagram. Do review Indian traditional conservation practices like 'Sacred groves.'",
      },
      {
        topicName: "Chapter 5: Towards Green Energy",
        questions: [
          {
            questionNumber: "Q.1(B)(3)",
            questionDescription: "Inverter converts DC to AC",
            marksScored: 1,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.2(A)(2)",
            questionDescription: "Importance of saving energy",
            marksScored: 0,
            maximumMarks: 2,
          },
          {
            questionNumber: "Q.2(B)(2)",
            questionDescription: "Biomass fuels examples",
            marksScored: 0.5,
            maximumMarks: 2,
          },
          {
            questionNumber: "Q.3(3)",
            questionDescription: "Nuclear power plant energy conversion",
            marksScored: 3,
            maximumMarks: 3,
          },
        ],
        chapterFeedback:
          "Focus on factual accuracy (e.g., biomass fuels). Great job on nuclear power plant process.",
      },
      {
        topicName: "Animal Classification",
        questions: [
          {
            questionNumber: "Q.1(A)(4)",
            questionDescription: "Pigeon's four-chambered heart",
            marksScored: 1,
            maximumMarks: 1,
          },
        ],
        chapterFeedback:
          "Understands key classification points (heart structure).",
      },
      {
        topicName: "Introduction to Microbiology",
        questions: [
          {
            questionNumber: "Q.1(A)(5)",
            questionDescription: "Bacteria for biofertilizer (Nostoc)",
            marksScored: 0,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.1(B)(4)",
            questionDescription: "Microbes decomposing rubber",
            marksScored: 0,
            maximumMarks: 1,
          },
        ],
        chapterFeedback:
          "Review essential microbial examples—especially Nostoc and rubber-decomposing species.",
      },
      {
        topicName: "Cell Biology and Biotechnology",
        questions: [
          {
            questionNumber: "Q.1(A)(1)",
            questionDescription: "Identify mitosis phase (Anaphase)",
            marksScored: 1,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.3(6)",
            questionDescription: "Role of biotechnology in agriculture",
            marksScored: 3,
            maximumMarks: 3,
          },
        ],
        chapterFeedback:
          "Great clarity on cell division phases and genetic engineering for crops.",
      },
      {
        topicName: "Social Health",
        questions: [
          {
            questionNumber: "Q.1(B)(5)",
            questionDescription: "Laughter club remedy for mental stress",
            marksScored: 1,
            maximumMarks: 1,
          },
          {
            questionNumber: "Q.2(B)(3)",
            questionDescription: "Factors for good social health",
            marksScored: 1.5,
            maximumMarks: 2,
          },
        ],
        chapterFeedback:
          "Positive handling of mental stress and social connectivity; add more detail on respect and acceptance.",
      },
      {
        topicName: "Disaster Management",
        questions: [],
        chapterFeedback:
          "No attempts or incomplete attempts; review pre- and post-disaster measures if time permits.",
      },
    ],

    // Analysis of student's strong and weak areas with correct chapter references
    strengths_and_weaknesses: {
      strengths: [
        "Heredity & Evolution (Ch.1): Excellent grasp on embryological evidences, evolution timeline, and sex determination.",
        "Cell Biology & Biotechnology (Ch.8): Perfect answers on mitosis phases and biotechnology applications in agriculture.",
      ],
      weaknesses: [
        "Introduction to Microbiology (Ch.7): Missed crucial examples like 'Nostoc' and rubber-decomposing microbes.",
        "Towards Green Energy (Ch.5): Confusion about biomass fuels and incomplete answer on energy-saving measures.",
      ],
    },

    // Recommended study strategies for improvement
    studyRecommendations: {
      improve_factual_recall: [
        "Q.1(A)(5): Revise Chapter 7 (Microbiology). You lost 1 mark for missing 'Nostoc' as the biofertilizer bacterium. Make flashcards of key microbes and their uses.",
        "Q.1(B)(4): Also from Chapter 7 (Microbiology), recall microbial species that decompose rubber (e.g., Actinomycetes). Be sure to list multiple correct examples in short-answer questions.",
      ],
      practice_complete_answers: [
        "Q.1(B)(1): In Chapter 3 (Male Reproduction), you only mentioned 'penis' but missed prostate gland, etc. Next time, list all unpaired organs for full marks.",
        "Q.2(A)(2): In Chapter 5 (Energy Conservation), you wrote about disaster management instead of saving energy. Always check the question topic carefully and organize key points before writing.",
      ],
      focus_on_visual_learning: [
        "Q.2(B)(2): You confused some biomass fuel examples (methanol, natural gas). Make a chart of common biomass fuels vs. fossil fuels to visualize the differences clearly.",
        "Q.3(3): You did well describing the nuclear power plant process (Chapter 5). Keep reinforcing your knowledge of flow diagrams and processes with practice sketches.",
      ],
      targeted_weaknesses: [
        "Chapter 2 (Life Processes - Part 1): Q.1(A)(2) on unisexual flowers lost you 1 mark. Quickly revise how unisexual/bisexual flowers differ, focusing on Androecium/Gynoecium.",
        "Chapter 7 (Microbiology): Missing or incomplete answers on microbes (Q.1(A)(5), Q.1(B)(4)). Memorize important species (e.g., Nostoc, Actinomycetes) and why they're significant.",
      ],
    },
  },
};
